import { UseSiteSettings } from '../../hooks/useSiteSettings'

export const eftAndTaxTitle = ({
  eftForm,
  taxIdForm,
}: Pick<UseSiteSettings, 'eftForm' | 'taxIdForm'>): string | undefined =>
  eftForm?.link && taxIdForm?.link
    ? `${eftForm.label || 'EFT'} & ${taxIdForm.label || 'Tax ID'} Forms`
    : eftForm?.link
      ? `${eftForm.label || 'EFT'} Form`
      : taxIdForm?.link
        ? `${taxIdForm.label} Form`
        : undefined
